export default {
  list: state => {
    return state.list;
  },
  listHomePage: state => {
    return state.list;
  },
  fullWidthBanner: state => {
    let frontPageListings = [];

    let array = ["Banner"];
    array.forEach(index => {
      let listing = state.list.find(listing => {
        return listing.frontPagePosition === index;
      });
      if (listing) {
        frontPageListings.push(listing);
      }
    });

    return frontPageListings;
  }
};
